/*=========================================================================================
  File Name: gameState.js
  Description: game Module State
==========================================================================================*/

export default {
  member: {
    username: null,
    balance: 0,
    prevBalance: null,
    currency: null,
  },
  video: '',
  game: {
    code: null,
    lang: 'en',
    rooms: [
      {
        game: '',
        isLocked: false,
        isShuffling: false,
        roomno: '',
        roomorder: '',
        shoe: '',
        timer: 0,
        type: 'BAC',
      },
      {
        game: '',
        isLocked: false,
        isShuffling: false,
        roomno: '',
        roomorder: '',
        shoe: '',
        timer: 0,
        type: 'BAC',
      },
      {
        game: '',
        isLocked: false,
        isShuffling: false,
        roomno: '',
        roomorder: '',
        shoe: '',
        timer: 0,
        type: 'BAC',
      },
      {
        game: '',
        isLocked: false,
        isShuffling: false,
        roomno: '',
        roomorder: '',
        shoe: '',
        timer: 0,
        type: 'BAC',
      },
      {
        game: '',
        isLocked: false,
        isShuffling: false,
        roomno: '',
        roomorder: '',
        shoe: '',
        timer: 0,
        type: 'BAC',
      },
      {
        game: '',
        isLocked: false,
        isShuffling: false,
        roomno: '',
        roomorder: '',
        shoe: '',
        timer: 0,
        type: 'BAC',
      },
    ],
  },
  levels: [],
  currentRoom: {
    intial: false,
    roomno: '',
    roomorder: '',
    result: '',
    state: 2,
    shoe: '',
    timer: 0,
    timerdate: '',
    card: [],
  },
  currentLevel: 1,
  betChips: [],
  bigeyeroadcount: 0,
  smallroadcount: 0,
  croadcount: 0,
  settings: {
    lobbyRoomDisplay: 'MAIN',
    cancelType: 'FROM_TIMER',
    cancelTime: '3',
    maxRoundRoomKick: '5',
    showFireworks: '1',
    videoTextKr: '',
    videoTextCn: '',
    videoTextEn: '',
    crossBets: false
  }
};
